import { render, staticRenderFns } from "./EducationalCategoryTable.vue?vue&type=template&id=3d764066&"
import script from "./EducationalCategoryTable.vue?vue&type=script&lang=js&"
export * from "./EducationalCategoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports